import { createElement } from 'react';

function FeatureFallback() {
  return /*#__PURE__*/createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 84",
    width: "100%",
    height: "100%",
    fill: "#CCD3D8"
  }, /*#__PURE__*/createElement("path", {
    d: "M68.61 66.45l-16.8-16.8c3.2-3.7 5.1-8.5 5.1-13.7 0-11.5-9.4-20.9-20.9-20.9s-21 9.4-21 20.9 9.4 20.9 20.9 20.9c5.2 0 10-1.9 13.7-5.1l16.8 16.8c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.5-.5.5-1.5 0-2.1zm-50.6-30.5c0-9.9 8-17.9 17.9-17.9s17.9 8 17.9 17.9-8 17.9-17.9 17.9-17.9-8-17.9-17.9z"
  }), /*#__PURE__*/createElement("path", {
    d: "M24.64 29.13h4.85v4.85h-4.85zM33.66 29.13h4.85v4.85h-4.85zM42.68 29.13h4.85v4.85h-4.85zM24.64 38.57h4.85v4.85h-4.85zM33.66 38.57h4.85v4.85h-4.85zM42.68 38.57h4.85v4.85h-4.85z"
  }, /*#__PURE__*/createElement("animate", {
    attributeName: "opacity",
    dur: "4s",
    keyTimes: "0;0.1667;0.333;0.5;0.667;0.833;1",
    values: "1;1;0;0;0;0;1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/createElement("path", {
    d: "M33.67 40.4l-.07-.94c-.14-1.91.47-3.89 2.16-5.9 1.37-1.62 2.3-2.92 2.3-4.32 0-1.51-.97-2.52-2.99-2.56-1.22 0-2.66.4-3.6 1.08l-1.04-3.17c1.26-.83 3.35-1.48 5.62-1.48 4.46 0 6.52 2.59 6.52 5.47 0 2.63-1.55 4.39-3.1 6.16-1.44 1.66-1.98 3.13-1.91 4.86v.79h-3.89zm1.8 7.81c-1.58 0-2.7-1.22-2.7-2.81 0-1.66 1.15-2.81 2.74-2.81 1.62 0 2.74 1.15 2.74 2.81 0 1.58-1.08 2.81-2.74 2.81h-.04z",
    opacity: "0"
  }, /*#__PURE__*/createElement("animate", {
    attributeName: "opacity",
    dur: "4s",
    keyTimes: "0;0.1667;0.333;0.5;0.667;0.833;1",
    values: "0;0;0;1;1;0;0",
    repeatCount: "indefinite"
  })));
}

export { FeatureFallback };
